import { useQuery } from '@tanstack/react-query'
import { useUser } from '~/features/auth/api/useUser'
import { JsonRpcError } from '~/types'
import { WithdrawRequestListResponse, WithdrawRequestsParams } from '../types'

export const useWithdrawRequests = ({ page = 1, page_size = 10, filters }: WithdrawRequestsParams) => {
    const { data: user } = useUser()
    /* A queue filtered to what is waiting is ordered by how long somebody has
     * been in it, and that has to happen where the paging happens. The browser
     * used to re-sort the rows it had been sent, so "waiting, longest first"
     * described one page while the genuinely oldest requests sat on page two. */
    const waiting = filters?.status === 'created' || filters?.status === 'submitted'
    const order_by = waiting ? 'oldest' : undefined
    return useQuery<WithdrawRequestListResponse, JsonRpcError>({
        queryKey: ['withdraw_requests', page, filters, page_size, order_by],
        queryFn: async () => {
            const res = await fetch('/rpc', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    jsonrpc: '2.0',
                    id: 1,
                    method: 'bank.withdraw_request.all',
                    params: {
                        page,
                        page_size,
                        filters,
                        order_by,
                        // Verdicts load per row, on expand: see useWithdrawVerdict.
                        with_verdicts: false,
                    },
                }),
            })
            const data = await res.json()
            if (data.error) {
                throw data
            } else {
                return data.result
            }
        },
        retry: false,
        keepPreviousData: true,
        enabled: user.is_auth && (user.is_marketing || user.is_executive),
    })
}
